// Production page helpers (HD-8): the page's own stage tabs, the status each one opens on, the ladder rung a card's
// status reads as, and the transition button labels in sentence case without arrows (DESIGN rev 2.1 §2.8, §2.9).
import { STAGES as LADDER } from '../../ui/stages';

export const STAGES = ['script', 'shoot', 'edit', 'review', 'post'];
export const STAGE_LABEL = { script: 'Script', shoot: 'Shoot', edit: 'Edit', review: 'Review', post: 'Post' };
// P-2: status to the stage the page opens on.
export const STATUS_STAGE = { Scripted: 'script', Filming: 'shoot', Filmed: 'shoot', Editing: 'edit', Incomplete: 'edit', Qual: 'review', Approved: 'review', Posted: 'post', Archived: 'script' };
export const STAGE_INDEX = { script: 0, shoot: 1, edit: 2, review: 3, post: 4 };

// §2.1: Incomplete is not a rung (Filming + the Incomplete condition); Archived (set aside) sits on Scripted.
export function ladderOf(status) {
  if (status === 'Incomplete') return 'Filming';
  if (status === 'Archived') return 'Scripted';
  return LADDER.includes(status) ? status : 'Scripted';
}

export function transitionLabel(status, isBack) {
  if (isBack) {
    const labels = { Scripted: 'Back to Scripted', Filming: 'Back to Filming', Filmed: 'Back to Filmed', Editing: 'Back to Editing', Qual: 'Back to Qual', Approved: 'Back to Approved' };
    return labels[status] || `Back to ${status}`;
  }
  const labels = { Filming: 'Start filming', Filmed: 'Mark filmed', Editing: 'Send to editing', Qual: 'Send for qual', Approved: 'Approve', Posted: 'Mark posted', Incomplete: 'Mark incomplete', Archived: 'Set aside' };
  return labels[status] || status;
}

export const plural = (n, word, many = `${word}s`) => `${n} ${n === 1 ? word : many}`;

// Fetch a signed URL and hand it to the browser as a download (the old pages' anchor click, unchanged).
export function openUrl(url) {
  const a = document.createElement('a'); a.href = url; a.rel = 'noopener'; document.body.appendChild(a); a.click(); a.remove();
}
